const routes = [
  {
    index: true,
    label: 'Junjie Xiong',
    path: '/',
  },
  // {
  //   label: 'About',
  //   path: '/about',
  // },
  {
    label: 'Home',
    path: '/',
  },
  {
    label: 'Publication',
    path: '/publications',
  },
  {
    label: 'Teaching & Mentoring',
    path: '/projects',
  },
  {
    label: 'Services',
    path: '/stats',
  },
];

export default routes;
